import { NgModule } from '@angular/core';
import { SharedPublicModule } from './_shared/shared-public.module';
import { PublicRoutingModule } from './public-routing.module';
import { PublicUnsubscribeComponent } from './public-unsubscribe/public-unsubscribe.component';

@NgModule({
  imports:      [
    SharedPublicModule,
    PublicRoutingModule,
  ],
  declarations: [
    PublicUnsubscribeComponent,
  ],

})
export class PublicModule {
}
